import { render, staticRenderFns } from "./AuthAdopt.vue?vue&type=template&id=785a2d80&scoped=true"
import script from "./AuthAdopt.vue?vue&type=script&lang=js"
export * from "./AuthAdopt.vue?vue&type=script&lang=js"
import style0 from "./AuthAdopt.vue?vue&type=style&index=0&id=785a2d80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785a2d80",
  null
  
)

export default component.exports